export enum UserRole {
  MERCHANT = 'MERCHANT',
  ADMIN = 'ADMIN',
  USER = 'USER',
  SUPPORT = 'SUPPORT',
  READER = 'READER',
  ADMIN_EDITOR = 'ADMIN_EDITOR',
  ADMIN_REPORTER = 'ADMIN_REPORTER',
  ADMIN_SUPPORTER = 'ADMIN_SUPPORTER',
  ADMIN_FINANCES = 'ADMIN_FINANCES',
}
